import React from "react";

export interface ProfileTab {
  id: string;
  label: string;
}

interface ProfileTabsProps {
  tabs: ProfileTab[];

  activeTab: string;

  onChange: (tabId: string) => void;

  className?: string;
}

export default function ProfileTabs({
  tabs,
  activeTab,
  onChange,
  className = "",
}: ProfileTabsProps) {
  return (
    <div
      className={`
        overflow-x-auto
        border-b
        border-slate-200
        ${className}
      `}
    >
      <div className="flex min-w-max gap-2 px-4">

        {tabs.map((tab) => {

          const active = tab.id === activeTab;

          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onChange(tab.id)}
              className={`
                whitespace-nowrap
                border-b-2
                px-4
                py-3
                text-sm
                font-medium
                transition-all

                ${
                  active
                    ? "border-blue-600 text-blue-600"
                    : "border-transparent text-slate-500 hover:text-slate-900"
                }
              `}
            >
              {tab.label}
            </button>
          );

        })}

      </div>
    </div>
  );
}